export default __webpack_public_path__ + "static/media/image-nom-mobile.6b9a654c.png";